// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lDm9","footer":"styles_footer__1w2nN","passCodeTooltip":"styles_passCodeTooltip__yyf2Q"};